import Vue from "vue";
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import 'iview/dist/styles/iview.css'
import iView from 'iview'
import iView_ptBR from 'iview/dist/locale/pt-BR';
import axios from 'axios'
import objectPath from 'object-path'
import VueMatchHeights from 'vue-match-heights'
import VTooltip from 'v-tooltip'

import App from "./App.vue";
import store from "./store";
import router from './router'

Vue.use(VTooltip)

const DEV = !location.href.includes('d2digit.al')
const PROD = !DEV

if (PROD) {
  Raven
    .config('https://561f423aad914957bc67cf516eff0bd6@sentry.io/296886')
    .addPlugin(RavenVue, Vue)
    .install()
}

Vue.config.productionTip = true;

Vue.use(iView, {
  locale: iView_ptBR
})

Vue.use(VueMatchHeights)

Vue.prototype.$axios = axios.create({
  baseURL: DEV ? `http://${location.hostname}:8888/` : 'https://orcamento.d2digit.al/api/',
  timeout: 5000
})

Vue.prototype.$objectPath = objectPath

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");